// extracted by mini-css-extract-plugin
module.exports = {"iconGap":"styles_iconGap__dScis","copyBtn":"styles_copyBtn__15G9P","card":"styles_card__2AT6R","hash":"styles_hash__3TEFy","headWrapper":"styles_headWrapper__rd5-4"};